// Copyright (c) Frisbii GmbH. All rights reserved.
'use strict';

var PaymentProviderGeneralSettingsController = function ($scope, $location, $routeParams, $http, GeneralPaymentSettings) {
    $scope.generalPaymentSettings = GeneralPaymentSettings.get();

    if (GeneralPaymentSettings.queryPlaceHolderDescription) {
        GeneralPaymentSettings.queryPlaceHolderDescription(function (response) {
            $scope.mandateReferencePlaceHolderDescription = response.data;           
        });
    }
    if (GeneralPaymentSettings.queryPlaceHolders) {
        GeneralPaymentSettings.queryPlaceHolders(function (response) {
            $scope.mandateReferencePlaceHolders = response.data;
        });
    }

    $scope.getTooltip = function (placeholder) {
        var res = ($scope.mandateReferencePlaceHolderDescription)
            ? $scope.mandateReferencePlaceHolderDescription[placeholder]
            : null;
        return res;
    };
    
    $scope.save = function () {
        $scope.generalPaymentSettings.$update({}, function () {
            $scope.notifySuccess();
        });
    };
    const Merchant = 'Merchant';
    //TODO: IT-10186 - define constants on server side
    $scope.mandateTextPlaceHolders = Object.freeze({
            Merchant : ['Merchant.CreditorId', 'Merchant.CompanyName', 'Merchant.AddressLine1', 'Merchant.AddressLine2', 'Merchant.StreetAddress', 'Merchant.HouseNumber', 'Merchant.ZIP', 'Merchant.City', 'Merchant.Country', 'Merchant.Phone', 'Merchant.Website', 'Merchant.EmailAddress'],
            'Customer' : ['FirstName', 'LastName','CompanyName','EmailAddress', 'StreetAddress', 'ZIP', 'City', 'Country'],
            'Direct Debit': ['Pay.BIC', 'Pay.IBAN', 'Pay.Holder', 'Pay.MandateReference'],
            'General' : ['CurrentDay']
    });
  
    $scope.currentMandateText = Merchant;
    $scope.isVisibleMandateTextPlaceHolder = function(phGroupName) {
        return $scope.currentMandateText === phGroupName;
    };
    $scope.toggleMandateTextVisibility = function(itemName) {
        if ($scope.currentMandateText === itemName)
            $scope.currentMandateText = null;
        else
            $scope.currentMandateText = itemName;
    };

    $scope.currentMandateRef = Merchant;
    $scope.isVisibleMandateRefPlaceHolder = function(phGroupName) {
        return $scope.currentMandateRef === phGroupName;
    };
    $scope.toggleMandateRefVisibility = function(itemName) {
        if ($scope.currentMandateRef === itemName)
            $scope.currentMandateRef = null;
        else
            $scope.currentMandateRef = itemName;
    };    
};
PaymentProviderGeneralSettingsController.$inject = ['$scope', '$rootScope', '$routeParams', '$http', 'GeneralPaymentSettings'];
